import styles from "./index.module.less";
import {
  ButtonField,
  Iconsvg,
  TextareaField,
  InputField,
} from "@wk/components-react16";
import { useState, useEffect, useCallback, useMemo, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useUser } from "@/utils/UserContext";
import {
  getDictIdByCode,
  getDictListById,
  getCaseList,
  getFinalCaseList,
} from "@/services/history";
import { getFinalJudge, editFinalJudge } from "@/services/judge";
import { Spin, InputNumber, ConfigProvider } from "antd";
import ModalConfirm from "../player/modal";
import { cloneDeep } from "lodash-es";
import { PdfHighlighter, PdfLoader } from "react-pdf-highlighter-extended";

import CommentForm from "./CommentForm";
import ExpandableTip from "./ExpandableTip";
import HighlightContainer from "./HighlightContainer";
import ContextMenu from "./ContextMenu";
// import Sidebar from "./Sidebar";
import { v4 as uuidv4 } from "uuid";

const expandedCaseList = [
  {
    title: "临床案例",
    key: "clinic",
    headList: ["指标名称", "权重", "指标内容"],
    tableList: [
      {
        first: "案例完整度及科学性",
        second: "66",
        list: [
          "真实且全面的患者基本情况及相关病史",
          "完善的体格检查、实验室检查及影像学检查（含【图片】并有重点总结）",
          "完整且合理的诊断、鉴别诊断",
          "患者最终的诊断结果、选择的治疗方式、结局转归（随访预后等），需要结合UpToDate等相关循证资源展示治疗方法或选择药物的正确科学、规范性",
          "临床诊疗过程全面、清晰、严谨且逻辑性强，对案例有充分的思考回顾（以该案例循证过程、证据应用或诊疗决策为基础，对自身工作或类似病例有完整的经验总结及启发描述）",
          "查阅UpToDate等相关循证资源，充分了解该疾病当前最佳的诊疗策略及学术研究进展",
        ],
      },
      {
        first: "案例实际价值",
        second: "22",
        list: [
          "选择案例为疑难、罕见病、多学科疾病、易误诊疾病和复杂疾病",
          "经过循证检索之后，诊断和/或治疗疾病的方法有进一步的创新或优化，在专业领域有推广价值或对临床诊治有范例作用",
          "从临床实际问题中获得科研启发，或该案例有进一步研究的价值，并且有后续跟进",
        ],
      },
      {
        first: "案例规范及美观性",
        second: "12",
        list: ["PPT制作美观，有视觉效果", "图片清晰典型，表格及流程图规范精炼"],
      },
      {
        first: "特殊加分",
        second: "20",
        list: [
          "有完整的应用临床循证数据库解决案例涉及问题(诊疗决策/辅助教学)的过程。详细介绍检索过程：如数据库的选择、检索词的优化、检索策略的改变、帮助您解决问题或者提供思路的具体内容等",
          "在案例决策中紧密结合UpToDate临床顾问内容及相关功能，清楚展现通过哪些内容得到启发，包括但不限于内容截图或在原内容上的总结。",
        ],
      },
    ],
  },

  {
    title: "住培案例",
    key: "residence",
    headList: ["指标名称", "权重", "指标内容"],
    tableList: [
      {
        first: "案例完整度及科学性",
        second: "66",
        list: [
          "真实且全面的患者基本情况及相关病史",
          "完善的体格检查、实验室检查及影像学检查（含【图片】并有重点总结）",
          "完整且合理的诊断、鉴别诊断",
          "患者最终的诊断结果、选择的治疗方式、结局转归（随访预后等），需要结合UpToDate等相关循证资源展示治疗方法或选择药物的正确科学、规范性",
          "临床诊疗过程全面、清晰、严谨且逻辑性强，对案例有充分的思考回顾（以该案例循证过程、证据应用或诊疗决策为基础，对自身工作或类似病例有完整的经验总结及启发描述）",
          "查阅UpToDate等相关循证资源，充分了解该疾病当前最佳的诊疗策略及学术研究进展",
        ],
      },
      {
        first: "案例实际价值",
        second: "22",
        list: [
          "选择案例为疑难、罕见病、多学科疾病、易误诊疾病和复杂疾病",
          "经过循证检索之后，诊断和/或治疗疾病的方法有进一步的创新或优化，在专业领域有推广价值或对临床诊治有范例作用",
          "从临床实际问题中获得科研启发，或该案例有进一步研究的价值，并且有后续跟进",
        ],
      },
      {
        first: "案例规范及美观性",
        second: "12",
        list: ["PPT制作美观，有视觉效果", "图片清晰典型，表格及流程图规范精炼"],
      },
      {
        first: "特殊加分",
        second: "20",
        list: [
          "有完整的应用临床循证数据库解决案例涉及问题(诊疗决策/辅助教学)的过程。详细介绍检索过程：如数据库的选择、检索词的优化、检索策略的改变、帮助您解决问题或者提供思路的具体内容等",
          "在案例决策中紧密结合UpToDate临床顾问内容及相关功能，清楚展现通过哪些内容得到启发，包括但不限于内容截图或在原内容上的总结。",
        ],
      },
    ],
  },

  {
    title: "教学案例",
    key: "teaching",
    headList: ["评分项", "权重", "评分内容"],
    tableList: [
      {
        first: "案例内容",
        second: "60",
        list: [
          "与教学有关的患者情况（病史、检查结果、诊疗方式等），展示教学过程并总结，应有教学模式的亮点总结，教学结果的展示或预判",
          "案例选择有带教价值，教学模式有创新（包括基于如床边教学、以问题为导向的教学、以病例为基础的教学等场景模式下的真实教学案例，或其他创新教学模式）",
          "有完整的应用临床循证数据库解决案例涉及问题(辅助教学)的过程。详细介绍检索过程：如数据库的选择、检索词的优化、检索策略的改变、帮助您解决问题或者提供思路的具体内容等",
          "对案例有充分的思考回顾：以该案例循证过程、证据应用或诊疗决策为基础，对自身工作或类似病例有完整的经验总结及启发描述",
          "PPT制作是否美观，有视觉效果",
        ],
      },
      {
        first: "思维过程",
        second: "30",
        list: [
          "教学过程是否全面、清晰、严谨且逻辑性强",
          "基于循证医学对检索结果的决策过程：对证据的思考分析和最佳证据的筛选过程；",
          "有对该案例在证据分析和筛选上的应用总结及反思",
        ],
      },
      {
        first: "与UpToDate结合度",
        second: "10",
        list: [
          "在案例决策中紧密结合UpToDate临床顾问内容及相关功能，清楚展现通过哪些内容得到启发，包括但不限于内容截图或在原内容上的总结。",
        ],
      },
    ],
  },

  {
    title: "科研案例",
    key: "research",
    headList: ["指标名称", "权重", "评分内容"],
    tableList: [
      {
        first: "案例内容",
        second: "60",
        list: [
          "与科研有关的患者情况（病史、检查结果、诊疗方式或临床情况总结等）科研课题内容完整性，包括课题详情、在研情况、结果预判（立项阶段的阐述亦可）",
          "所选课题是否国内外未见报道；或在类似研究上有新颖点促使该课题有新的发展、补充或修正；国外已有研究，但尚需结合我国实际进行探素，填补国内此领域的空白，对临床的意义等",
          "有完整的应用临床循证数据库解决案例涉及问题(助力科研创新)的过程。详细介绍检索过程：如数据库的选择、检索词的优化、检索策略的改变、帮助您解决问题或者提供思路的具体内容等",
          "对案例有充分的思考回顾：以该案例循证过程、证据应用或诊疗决策为基础，对自身工作或类似病例有完整的经验总结及启发描述",
          "PPT制作是否美观，有视觉效果",
        ],
      },
      {
        first: "思维过程",
        second: "30",
        list: [
          "科研过程是否全面、清晰、严谨且逻辑性强",
          "基于循证医学对检索结果的决策过程：对证据的思考分析和最佳证据的筛选过程",
          "有对该案例在证据分析和筛选上的应用总结及反思",
        ],
      },
      {
        first: "与UpToDate组合度",
        second: "10",
        list: [
          "在案例决策中紧密结合UpToDate临床顾问内容及相关功能，清楚展现通过哪些内容得到启发，包括但不限于内容截图或在原内容上的总结。",
        ],
      },
    ],
  },

  {
    title: "管理案例",
    key: "management",
    headList: ["评分项", "权重", "评分内容"],
    tableList: [
      {
        first: "案例完整度及合理性",
        second: "50",
        list: [
          "解决医务、教学、住培或科研方面的统筹管理相关问题",
          "清晰描述案例背景，待解决问题，及其影响和意义；",
          "呈现管理过程：分析-计划-执行-跟进-反馈-效果等相关环节",
        ],
      },
      {
        first: "案例实际价值",
        second: "20",
        list: [
          "选择案例可体现与医院现有流程的差异，显著改善管理效果",
          "案例具有普遍和借鉴意义，管理方法有创新性",
          "如何解决计划或执行中遇到的问题",
        ],
      },
      {
        first: "循证医学价值",
        second: "20",
        list: [
          "体现利用相关循证资源解决管理问题的优势",
          "在案例决策中紧密结合UpToDate临床顾问内容及相关功能，清楚展现通过哪些内容给予了支持。",
        ],
      },
      {
        first: "案例规范及美观性",
        second: "10",
        list: ["符合大赛案例规范；", "图片清晰典型，表格及流程图规范精炼"],
      },
    ],
  },
];

const externalCaseColor = ["#007AC3", "#E5202E", "#888888", "#85BC20"];

const ExternalRating = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { judge } = useUser();
  const [userInfo, setUserInfo] = useState();
  const [anLiList, setAnLiList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [isExpanded, setIsExpanded] = useState(true);

  const [activeItem, setActiveItem] = useState(); // 当前选中的案例
  const [finalJudge, setFinalJudge] = useState(); // 终评数据
  const [alList, setAlList] = useState([]); // 案例列表

  const [activeTab, setActiveTab] = useState("score"); // 'score' or 'comment'

  const [scoreList, setScoreList] = useState([]); // 评分标准列表
  const [isSaveLoading, setIsSaveLoading] = useState(false);

  const [isMessageOpen, setIsMessageOpen] = useState(false);
  const [messageText, setMessageText] = useState("");

  const highlighterUtilsRef = useRef();
  const [highlights, setHighlights] = useState([]);
  const [contextMenu, setContextMenu] = useState(null);

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  const getCaseLists = async (params) => {
    try {
      let activeItemValue = {};
      let finalJudgeValue = {};
      setIsLoading(true);
      const res = await getFinalCaseList(params);

      if (res.code === 200) {
        const queryParams = new URLSearchParams(location.search);
        const id = queryParams.get("id"); // 获取查询参数 id
        let list = res.result.records;
        let paramId = "";
        if (id) {
          let item = list.find((item) => item?.activityId == id);
          if (item) {
            const clonedItem = cloneDeep(item);
            // 只有当前浏览器使用https协议时，才将http链接转换为https
            if (
              window.location.protocol === "https:" &&
              clonedItem?.activityParticipateInfo?.fileUrl.startsWith("http://")
            ) {
              clonedItem.activityParticipateInfo.fileUrl =
                clonedItem?.activityParticipateInfo?.fileUrl.replace(
                  "http://",
                  "https://"
                );
            }
            setActiveItem(clonedItem);
            activeItemValue = item;
            list = [item, ...list.filter((item) => item?.activityId != id)];
            paramId = item.id;
          } else {
            const clonedItem = cloneDeep(list[0]);
            // 只有当前浏览器使用https协议时，才将http链接转换为https
            if (
              window.location.protocol === "https:" &&
              clonedItem?.activityParticipateInfo?.fileUrl.startsWith("http://")
            ) {
              clonedItem.activityParticipateInfo.fileUrl =
                clonedItem?.activityParticipateInfo?.fileUrl.replace(
                  "http://",
                  "https://"
                );
            }
            setActiveItem(clonedItem);
            activeItemValue = list[0];
            paramId = list[0].id;
          }
        } else {
          const clonedItem = cloneDeep(list[0]);
          // 只有当前浏览器使用https协议时，才将http链接转换为https
          if (
            window.location.protocol === "https:" &&
            clonedItem?.activityParticipateInfo?.fileUrl.startsWith("http://")
          ) {
            clonedItem.activityParticipateInfo.fileUrl =
              clonedItem?.activityParticipateInfo?.fileUrl.replace(
                "http://",
                "https://"
              );
          }
          setActiveItem(clonedItem);
          activeItemValue = list[0];
          paramId = list[0].id;
        }

        const resData = await getFinalJudge(paramId);
        if (resData.code === 200) {
          let annotation = resData.result.annotation;
          if (annotation) {
            try {
              annotation = JSON.parse(annotation);
            } catch (error) {
              annotation = [];
            }
          }
          setHighlights(annotation || []);
          setFinalJudge(resData.result);

          finalJudgeValue = resData.result;
        }

        setAnLiList(list);
      }
      let alListValue = await getAlList();
      getScoreList(activeItemValue, alListValue, finalJudgeValue);
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  const getList = useCallback(() => {
    if (!userInfo?.id) return;
    const params = {
      pageNo: 1,
      pageSize: 10000000,
      // px: "2",
      judgeId: userInfo.id,
      // belongYear: "2025",
    };
    getCaseLists(params);
  }, [userInfo]);

  const handleCaseClick = async (item) => {
    if (item.id === activeItem?.id) {
      return;
    }
    try {
      setIsLoading(true);
      const clonedItem = cloneDeep(item);
      // 只有当前浏览器使用https协议时，才将http链接转换为https
      if (
        window.location.protocol === "https:" &&
        clonedItem?.activityParticipateInfo?.fileUrl.startsWith("http://")
      ) {
        clonedItem.activityParticipateInfo.fileUrl =
          clonedItem?.activityParticipateInfo?.fileUrl.replace(
            "http://",
            "https://"
          );
      }
      setActiveItem(clonedItem);
      const paramId = item.id;
      const resData = await getFinalJudge(paramId);
      if (resData.code === 200) {
        let annotation = resData.result.annotation;
        if (annotation) {
          try {
            annotation = JSON.parse(annotation);
          } catch (error) {
            annotation = [];
          }
        }
        setHighlights(annotation || []);
        setFinalJudge(resData.result);
        getScoreList(item, alList, resData.result);
      }
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  const getCaseTypeDict = async (code) => {
    try {
      const resList = await getDictIdByCode({ code });
      const id = resList?.result?.records[0]?.id || "";
      const itemList = await getDictListById({ dictId: id, pageSize: -1 });
      return itemList?.result?.records || [];
    } catch (error) {
      return [];
    }
  };

  const getAlList = async () => {
    const list = await getCaseTypeDict("al");
    setAlList(list);
    return list;
  };

  const getScoreList = (activeItemValue, alListValue, finalJudgeValue) => {
    const alItem = alListValue.find(
      (item) => item.id === activeItemValue?.activityParticipateInfo?.caseType
    );
    const expandedCaseItem = expandedCaseList.find(
      (item) => item.title == alItem?.itemText
    ); // 找到对应的评分项

    let list = expandedCaseItem?.tableList || [];

    let finalJudgeScore = {};
    try {
      finalJudgeScore = JSON.parse(finalJudgeValue?.options || "{}");
    } catch (error) {
      finalJudgeScore = {};
    }
    list = list.map((item, index) => {
      let score = finalJudgeScore[item.first] || null;
      return {
        isExpanded: index === 0,
        score: score,
        ...item,
      };
    });

    setScoreList(list);
  };

  const totalScore = useMemo(() => {
    return scoreList.reduce((total, item) => {
      return total + (item.score || 0);
    }, 0);
  }, [scoreList]);

  const updateAnLiList = useCallback(async () => {
    if (!userInfo?.id) return;
    const params = {
      pageNo: 1,
      pageSize: 10000000,
      // px: "2",
      judgeId: userInfo.id,
      // belongYear: "2025",
    };
    try {
      setIsLoading(true);
      const res = await getFinalCaseList(params);
      if (res.code === 200) {
        setAnLiList(res.result.records);
      }
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  }, [userInfo]);

  const submit = async () => {
    let isNoScore = scoreList.some((item) => !item.score && item.score !== 0);
    if (isNoScore) {
      setMessageText("请完成所有评分项");
      setIsMessageOpen(true);
      return;
    }
    let totalScore = scoreList.reduce((total, item) => {
      return total + (item.score || 0);
    }, 0);
    let options = {};
    scoreList.forEach((item) => {
      options[item.first] = item.score;
    });

    const params = cloneDeep(finalJudge);
    params.options = JSON.stringify(options);
    params.score = totalScore;
    params.annotation = JSON.stringify(highlights);

    console.log(params);

    try {
      setIsSaveLoading(true);
      let res = await editFinalJudge(params);
      if (res.code === 200) {
        await updateAnLiList();
        setMessageText("评分提交成功");
        setIsMessageOpen(true);
        setTimeout(() => {
          setIsMessageOpen(false);
        }, 3000);
        // setMessageText("保存成功");
        // setIsMessageOpen(true);
      } else {
        setMessageText(res.message);
        setIsMessageOpen(true);
      }
    } catch (error) {
    } finally {
      setIsSaveLoading(false);
    }
  };

  const editComment = (highlight) => {
    if (!highlighterUtilsRef.current) return;

    const editCommentTip = {
      position: highlight.position,
      content: (
        <CommentForm
          placeHolder={highlight.comment}
          onSubmit={(input) => {
            editHighlight(highlight.id, { comment: input });
            highlighterUtilsRef.current.setTip(null);
            highlighterUtilsRef.current.toggleEditInProgress(false);
          }}
        ></CommentForm>
      ),
    };

    highlighterUtilsRef.current.setTip(editCommentTip);
    highlighterUtilsRef.current.toggleEditInProgress(true);
  };

  const deleteHighlight = (highlight) => {
    setHighlights(highlights.filter((h) => h.id != highlight.id));
  };

  const handleContextMenu = (event, highlight) => {
    event.preventDefault();

    setContextMenu({
      xPos: event.clientX,
      yPos: event.clientY,
      deleteHighlight: () => deleteHighlight(highlight),
      editComment: () => editComment(highlight),
    });
  };

  const addHighlight = (highlight, comment) => {
    setHighlights([{ ...highlight, comment, id: uuidv4() }, ...highlights]);
  };

  const editHighlight = (idToUpdate, edit) => {
    setHighlights(
      highlights.map((highlight) =>
        highlight.id === idToUpdate ? { ...highlight, ...edit } : highlight
      )
    );
  };

  useEffect(() => {
    setUserInfo(judge || {});
  }, [judge]);

  useEffect(() => {
    getList();
  }, [userInfo]);

  useEffect(() => {
    const handleClick = () => {
      if (contextMenu) {
        setContextMenu(null);
      }
    };

    document.addEventListener("click", handleClick);

    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, [contextMenu]);

  return (
    <>
      <Spin spinning={isLoading} wrapperClassName={styles["spin-box"]}>
        <div className={styles["external-rating-box"]}>
          <div className="top">
            <div
              className={`left-box ${isExpanded ? "expanded" : "collapsed"}`}
            >
              {isExpanded ? (
                <>
                  <div className="case-list-header">
                    <div className="list-title">案例列表</div>

                    <div onClick={toggleExpanded} style={{ cursor: "pointer" }}>
                      <Iconsvg
                        name="chevron-double-left"
                        size={14}
                        color="#353535"
                      />
                    </div>
                  </div>

                  <div className="case-list">
                    {anLiList.map((item) => (
                      <div
                        key={item.id}
                        className={`case-item ${
                          activeItem?.id == item.id ? "active" : ""
                        }`}
                        onClick={() => handleCaseClick(item)}
                      >
                        <Iconsvg
                          name={
                            item?.score || item?.score === 0
                              ? "check-circle"
                              : "question"
                          }
                          size={16}
                          color={
                            item?.score || item?.score === 0
                              ? "#85BC20"
                              : "#FD2929"
                          }
                        />

                        <div className="case-title">
                          {item?.activityParticipateInfo?.name}
                        </div>
                      </div>
                    ))}
                  </div>
                </>
              ) : (
                <div onClick={toggleExpanded} style={{ cursor: "pointer" }}>
                  <Iconsvg
                    name="chevron-double-right"
                    size={14}
                    color="#353535"
                  />
                </div>
              )}
            </div>
            <div className="right-box">
              <div className="pdf-preview">
                {activeItem?.activityParticipateInfo?.fileUrl ? (
                  <div
                    style={{
                      height: "100%",
                      width: "100%",
                      overflow: "hidden",
                      position: "relative",
                      flexGrow: 1,
                    }}
                  >
                    <PdfLoader
                      document={activeItem?.activityParticipateInfo?.fileUrl}
                    >
                      {(pdfDocument) => (
                        <PdfHighlighter
                          enableAreaSelection={(event) => event.altKey}
                          pdfDocument={pdfDocument}
                          utilsRef={(_pdfHighlighterUtils) => {
                            highlighterUtilsRef.current = _pdfHighlighterUtils;
                          }}
                          textSelectionColor={undefined}
                          onSelection={undefined}
                          selectionTip={
                            <ExpandableTip addHighlight={addHighlight} />
                          }
                          highlights={highlights}
                        >
                          <HighlightContainer
                            editHighlight={editHighlight}
                            onContextMenu={handleContextMenu}
                          />
                        </PdfHighlighter>
                      )}
                    </PdfLoader>
                  </div>
                ) : (
                  <div className="pdf-placeholder">
                    <div>暂无PDF文件</div>
                  </div>
                )}
              </div>

              <ConfigProvider
                theme={{
                  components: {
                    InputNumber: {
                      activeBorderColor: "#000",
                      activeShadow: "none",
                      handleHoverColor: "#005b92 !important",
                      hoverBorderColor: "#005b92 !important",
                    },
                  },
                }}
              >
                <div className="score-box">
                  <div className="score-tabs">
                    <div
                      className={`tab ${activeTab === "score" ? "active" : ""}`}
                      onClick={() => setActiveTab("score")}
                    >
                      打分
                    </div>
                    <div
                      className={`tab ${
                        activeTab === "comment" ? "active" : ""
                      }`}
                      onClick={() => setActiveTab("comment")}
                    >
                      评论
                    </div>
                  </div>

                  {activeTab === "score" && (
                    <>
                      <div className="score-content">
                        {scoreList.map((item, index) => (
                          <div
                            key={item.first}
                            className="score-item"
                            style={{
                              borderTop: `3px solid ${externalCaseColor[index]}`,
                            }}
                          >
                            <div className="score-input">
                              <InputNumber
                                min={0}
                                max={Number(item.second)}
                                value={item.score}
                                onChange={(value) => {
                                  item.score = value;
                                  setScoreList([...scoreList]);
                                }}
                              />

                              <div className="max-score">{item.second}</div>
                            </div>

                            <div className="score-title">
                              <div className="text">{item.first}</div>
                              <div
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  item.isExpanded = !item.isExpanded;
                                  setScoreList([...scoreList]);
                                }}
                              >
                                <Iconsvg
                                  name={
                                    item?.isExpanded
                                      ? "chevron-up"
                                      : "chevron-down"
                                  }
                                  size={20}
                                  color="#757575"
                                />
                              </div>
                            </div>

                            {item.isExpanded && (
                              <div className="score-dec">
                                {item?.list?.map((text, index) => (
                                  <div key={text} className="score-dec-item">
                                    {index + 1}.{text}
                                  </div>
                                ))}
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                      <div className="advice-box">
                        <div className="advice-title">
                          评审意见<span> (可选)</span>
                        </div>
                        <TextareaField>
                          <textarea
                            value={finalJudge?.advice || ""}
                            placeholder="请输入内容"
                            onChange={(e) => {
                              setFinalJudge({
                                ...finalJudge,
                                advice: e.target.value,
                              });
                            }}
                            maxLength={200}
                          ></textarea>
                        </TextareaField>
                      </div>

                      <div className="total-score">
                        <div className="total-score-title">总分</div>
                        <InputField isDisabled={true}>
                          <input
                            type="text"
                            value={totalScore}
                            onChange={() => {}}
                          />
                        </InputField>
                      </div>
                    </>
                  )}

                  {activeTab === "comment" && (
                    <div className="comment-content">
                      {highlights.map((item) => (
                        <div key={item.id} className="comment-item">
                          {item?.content?.text && (
                            <div className="pdf-highlight-text">
                              {item.content.text.trim()}
                            </div>
                          )}
                          {item?.content?.text && <div className="line-box" />}
                          <div className="comment-text">{item?.comment}</div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </ConfigProvider>
            </div>
          </div>

          <div className="footer">
            <ButtonField mode={"ghost"}>
              <button
                type="button"
                onClick={() => {
                  // setIsSaveOpen(true);
                  navigate("/judgesHomepage");
                }}
                disabled={isSaveLoading || !userInfo?.id}
              >
                取消
              </button>
            </ButtonField>

            <ButtonField>
              <button
                type="button"
                onClick={() => {
                  submit();
                }}
                disabled={isSaveLoading || !userInfo?.id}
              >
                提交
                {isSaveLoading && <Iconsvg name="spinner-alt" isSpin></Iconsvg>}
              </button>
            </ButtonField>
          </div>

          <ModalConfirm
            isFooter={false}
            isOpen={isMessageOpen}
            onClose={() => {
              setIsMessageOpen(false);
              setMessageText("");
            }}
            children={<div className="modal-body-text">{messageText}</div>}
            title={"消息提示"}
            onConfirm={() => {
              setIsMessageOpen(false);
              setMessageText("");
            }}
            okText="确认"
          />
        </div>
      </Spin>

      {contextMenu && <ContextMenu {...contextMenu} />}
    </>
  );
};

export default ExternalRating;
